import { useEffect, useState } from "react";
import { alpha } from "@mui/material/styles";
import {
  Card,
  Button,
  Stack,
  InputBase,
  Box,
  Typography,
  CardHeader,
  Link,
  IconButton,
  TextField
} from "@mui/material";
import { CustomAvatar } from "../components/custom-avatar";
import { FundingPackageNote } from "./types";
import { fDate } from "../utils/formatTime";
import Iconify from "../../minimals/components/iconify";
import axios from "axios";
import NotesHistory from "./NotesHistory";


interface Props {
  fundingPackageId: number | undefined;
}
export default function NotesSection(props: Props) {
  const [noteText, setNoteText] = useState("");
  const [editNoteId, setEditNoteId] = useState<number | null>(null);
  const [notes, setNotes] = useState<FundingPackageNote[]>([]);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const getNotes = async () => {
    const { data } = await axios.get(
      `/api/FundingPackages/packages/GetFundingPackageNotesById?fundingPackageId=${props.fundingPackageId}`
    );
    setNotes(data);
  };

  const handleSaveNote = async () => {
    if (!props.fundingPackageId || !noteText.trim()) return;
    setSubmitting(true);
    await axios.post(`/api/FundingPackages/packages/SaveNote`, {
      fundingPackageId: props.fundingPackageId,
      noteText: noteText,
      id: editNoteId ?? 0
    });
    setSubmitting(false);
    setEditNoteId(null);
    setNoteText("");
    await getNotes();
  };

  const startEdit = (note: FundingPackageNote) => {
    setEditNoteId(note.id);
    setNoteText(note.noteText);
  };

  useEffect(() => {
    if (!props.fundingPackageId) return;
    getNotes();
  }, [props.fundingPackageId]);

  return (
    <Card sx={{ p: 3 }}>
     <NotesHistory notes={notes || []} />
      <InputBase
        value={editNoteId === null ? noteText : ""}
        multiline
        fullWidth
        rows={4}
        placeholder="Add a note..."
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 1,
          border: (theme) => `solid 1px ${alpha(theme.palette.grey[500], 0.32)}`
        }}
        disabled={editNoteId !== null}
        onChange={(e) => setNoteText(e.target.value)}
      />

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" spacing={1} alignItems="center" sx={{ color: "text.secondary" }}></Stack>
        <Button variant="contained" onClick={handleSaveNote} disabled={submitting || noteText.trim() === ""}>
          {submitting ? "Submitting" : "Save Note"}
        </Button>
      </Stack>
      {/* {notes.map((n: FundingPackageNote) => {
        return (
          <Card sx={{ marginTop: 2 }}>
            <CardHeader
              disableTypography
              title={
                <Box>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CustomAvatar alt={n?.createdByUser?.fullName} name={n?.createdByUser?.fullName} />
                    <Box>
                      <Link color="inherit" variant="subtitle2">
                        {n?.updatedAt && n.updatedAt > n.createdAt
                          ? `edited by ${n?.createdByUser?.fullName}`
                          : n?.createdByUser?.fullName}
                      </Link>
                      <Typography variant="caption" component="div" sx={{ color: "text.secondary" }}>
                        {n?.createdAt && fDate(n.createdAt)}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              }
              action={
                <Box>
                  <IconButton onClick={() => startEdit(n)} color="primary">
                    <Iconify icon="eva:edit-fill" />
                  </IconButton>
                </Box>
              }
            />
            {editNoteId === n.id ? (
              <Box sx={{ p: 2 }}>
                <TextField fullWidth multiline value={noteText} onChange={(e) => setNoteText(e.target.value)} />
                <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                  <Button variant="contained" onClick={handleSaveNote}>
                    Save
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setEditNoteId(null);
                      setNoteText("");
                    }}
                  >
                    Cancel
                  </Button>
                </Stack>
              </Box>
            ) : (
              <Typography sx={{ p: 3, whiteSpace: "pre-wrap" }}>{n.noteText}</Typography>
            )}
          </Card>
        );
      })} */}
    </Card>
  );
}
